import { getAside2components } from "./getVizDetails";
import { buildCustomization } from "./buildInitialSheetState";

const transformQuery = (inputexistingQuery) => {
  // const { groupByFields: incomingColumns, rows: incomingRows } = inputexistingQuery
  const incomingColumns = inputexistingQuery.groupByFields || [];
  const incomingRows = inputexistingQuery.rows || [];
  // console.log(incomingColumns, incomingRows);
  return {
    ...inputexistingQuery,
    groupByFields: incomingRows,
    rows: incomingColumns,
  };
};

const transformQueryGuidelines = (rawOldVizQuery) => {
  const oldRowsIndex = rawOldVizQuery.findIndex((item) => {
    return item.reduxKey === "rows";
  });

  const oldColumnsIndex = rawOldVizQuery.findIndex((item) => {
    return item.reduxKey === "groupByFields";
  });

  // console.log(oldColumnsIndex, oldRowsIndex, rawOldVizQuery);

  if (oldRowsIndex > -1 && oldColumnsIndex > -1) {
    // console.log("Both rows and columns exist.");
    return rawOldVizQuery;
  } else if (oldRowsIndex === -1 && oldColumnsIndex > -1) {
    // console.log("Only groupByFields exists.");
    const updatedArray = rawOldVizQuery.map((item, index) =>
      index === oldColumnsIndex ? { ...item, reduxKey: "rows" } : item
    );
    return updatedArray;
  } else if (oldRowsIndex > -1 && oldColumnsIndex === -1) {
    // console.log("Only rows exist.");
    return rawOldVizQuery;
  }

  // console.log("Neither rows nor groupByFields exist.");
  return rawOldVizQuery;
};

const convertQueries = ({
  rawOldVizQuery,
  rawNewVizQuery,
  inputexistingQuery,
  VizType,
  NewVizType,
  runModification = false,
}) => {
  if (!runModification) {
    return {
      oldVizQuery: rawOldVizQuery,
      newVizQuery: rawNewVizQuery,
      existingQuery: inputexistingQuery,
    };
  } else {
    const transformedquery = transformQuery(inputexistingQuery);
    // console.log(transformedquery, inputexistingQuery);
    const transformedQueryGuidelinnes =
      transformQueryGuidelines(rawOldVizQuery);
    // console.log(transformedQueryGuidelinnes);
    // if (["simpleTable","table"].includes(VizType) || New["simpleTable","table"].includes(VizType)) {
    //   // console.log(VizType);

    //   // console.log(NewVizType);

    // } else {
    // }
    // return {
    //   oldVizQuery: rawOldVizQuery,
    //   newVizQuery: rawNewVizQuery,
    //   existingQuery: inputexistingQuery,
    // };
    return {
      oldVizQuery: transformedQueryGuidelinnes,
      newVizQuery: rawNewVizQuery,
      existingQuery: transformedquery,
    };
  }
};
// these charts takes groupbyFields as x-axis and rows as stack(one above one) "linechart","areachart","stackedbarchart","scatterchart","treechart","stackedbarchartimage"
// simpleTable take row as row and groupByField as columns
// if you are changing the viztype 1d two 2d check is their any need two transform the query if yes mentione the chart inside the array created in the 3rd condition 1D to 2D and if newviztype is like simpleTable their is no need to transform the query then dont even mention it
function chartCategory(oldVizType, newVizType) {
  const twoDimensionalCharts = [
    "simpleTable",
    "linechart",
    "areachart",
    "stackedbarchart",
    "scatterchart",
    "treechart",
    "stackedbarchartimage",
  ];
  const oneDimensionalCharts = [
    "piechart",
    "radarchart",
    "combochart",
    "bigNumber",
    "table",
  ];
  function getDimension(vizType) {
    if (twoDimensionalCharts.includes(vizType)) return "2D";
    if (oneDimensionalCharts.includes(vizType)) return "1D";
    return "Unknown";
  }

  return {
    oldVizType: getDimension(oldVizType),
    newVizType: getDimension(newVizType),
  };
}
const handleRunModification = ({ oldVizType, newVizType, oldVizQuery }) => {
  // console.log(oldVizType);

  // console.log(newVizType);

  // // console.log(oldVizQuery);
  const { rows, groupByFields } = oldVizQuery;
  const { oldVizType: oldVizTypeDimension, newVizType: newVizTypeDimension } =
    chartCategory(oldVizType, newVizType);
  // console.log(oldVizTypeDimension, newVizTypeDimension);
  if (oldVizTypeDimension === "1D" && newVizTypeDimension === "1D") {
    return false;
  }
  if (oldVizTypeDimension === "2D" && newVizTypeDimension === "1D") {
    if (rows.length && groupByFields.length) {
      return false;
    }
    if (rows.length === 0 && groupByFields.length) {
      return false;
    }
    if (rows.length && groupByFields.length === 0) {
      return true;
    }
  }
  if (oldVizTypeDimension === "1D" && newVizTypeDimension === "2D") {
    if (
      groupByFields.length &&
      [
        "linechart",
        "areachart",
        "stackedbarchart",
        "scatterchart",
        "treechart",
        "stackedbarchartimage",
      ].includes(newVizType)
    ) {
      return false;
    } else {
      return true;
    }
  }
  if (oldVizTypeDimension === "2D" && newVizTypeDimension === "2D") {
    if (rows.length && groupByFields.length) {
      // console.log("ji");
      return false;
    }
    if (rows.length === 0 && groupByFields.length) {
      // console.log("ji");
      if (oldVizType !== "simpleTable" && newVizType === "simpleTable") {
        return true;
      } else {
        return false;
      }
    }
    if (rows.length && groupByFields.length === 0) {
      // console.log("ji");
      return true;
    }
  }
};
const buildModifiedSheetState = (existingState, NewVizType) => {
  // console.log(existingState);
  const oldVizType = existingState.VizType;
  // console.log(oldVizType);
  // console.log(NewVizType);
  const {
    ID,
    SheetName,
    VizType,
    query: inputexistingQuery,
    // customization: existingCustomization,
    dataSourceID,
    actions,
    isSheetVisible = true,
  } = existingState;

  // console.log(dataSourceID);
  // const newDummyState = { ...existingState, VizType: NewVizType };

  const query = {};
  const newState = {
    ID,
    SheetName,
    VizType: NewVizType,
    sheetType: "chart",
    dataSourceID,
    query,
    isSheetVisible,
  };

  const {
    DataArrayComponents: rawNewVizQuery,
    CustomizeArrayComponents: newVizCustomization,
  } = getAside2components(NewVizType);
  // console.log(NewVizType, newVizCustomization);

  const {
    DataArrayComponents: rawOldVizQuery,
    // CustomizeArrayComponents: oldVizCustomization,
  } = getAside2components(VizType);
  // console.log(
  //   handleRunModification({
  //     oldVizType,
  //     newVizType: NewVizType,
  //     oldVizQuery: existingState.query,
  //   })
  // );

  const runModification = handleRunModification({
    oldVizType,
    newVizType: NewVizType,
    oldVizQuery: existingState.query,
  });
  const { oldVizQuery, newVizQuery, existingQuery } = convertQueries({
    rawOldVizQuery,
    rawNewVizQuery,
    inputexistingQuery,
    VizType,
    NewVizType,
    runModification,
  });
  // // console.log(existingQuery);
  // console.log(runModification);

  // console.log(newVizQuery);

  // Helper function to filter and set the query array
  const filterAndSetQueryArray = (reduxKey, dataTypeAllowed, single) => {
    const filterdDataTypeArray =
      existingQuery[reduxKey]?.filter(
        (item) => item.dataType.toLowerCase() === dataTypeAllowed.toLowerCase()
      ) || [];
    // console.log(filterdDataTypeArray);
    if (filterdDataTypeArray.length) {
      newState.query[reduxKey] = single
        ? [filterdDataTypeArray[0]]
        : filterdDataTypeArray;
    } else {
      newState.query[reduxKey] = [];
    }
  };

  newVizQuery.forEach((item) => {
    const { reduxKey, single, dataTypeAllowed, itemInArray } = item;
    const oldItem = oldVizQuery.find(
      (olditem) => olditem.reduxKey === reduxKey
    );
    // console.log(reduxKey);

    if (
      oldItem &&
      (oldItem.dataTypeAllowed === dataTypeAllowed || dataTypeAllowed === "all")
    ) {
      if (itemInArray) {
        const existingArray = Array.isArray(existingQuery[reduxKey])
          ? existingQuery[reduxKey]
          : [];
        newState.query[reduxKey] =
          single && existingArray.length
            ? [existingArray[0]]
            : existingArray;
      } else {
        newState.query[reduxKey] = existingQuery[reduxKey];
      }
    } else if (oldItem && oldItem.dataTypeAllowed !== dataTypeAllowed) {
      if (itemInArray) {
        filterAndSetQueryArray(reduxKey, dataTypeAllowed, single);
      } else {
        newState.query[reduxKey] = "";
      }
    } else {
      newState.query[reduxKey] = itemInArray ? [] : "";
    }
  });

  // console.log(newState.query);

  const customization = buildCustomization(newVizCustomization);
  newState.customization = customization;

  //manage Actions
  // Manage Actions
  const { sort } = actions;

  // Create an array of acceptable sort fields
  const acceptableSortFields = [];
  query.rows?.forEach((item) => acceptableSortFields.push(item.rename));
  if (query?.valueColumns) {
    query?.valueColumns.forEach((item) => {
      const responseKey = `${item.measure.value}_${item.rename}`;
      acceptableSortFields.push(responseKey);
    });
  }

  // console.log(acceptableSortFields);

  // Filter the sort array based on the acceptableSortFields
  const filteredSort = sort.filter((sortItem) =>
    acceptableSortFields.includes(sortItem.column)
  );

  // Add the modified actions object to the new state
  newState.actions = {
    ...actions,
    sort: filteredSort,
  };

  return newState;
};

export { buildModifiedSheetState };
